import Home from "../../../pages/Home";

export default function HomePage() {
  return <Home />;
}
